<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11"><span class="th12">ACKNOWLEDGMENTS</span></h1>
<p class="p6"> </p>
<p class="p6"> </p>
<p class="p7">I have wanted to write a “dinosaur novel” for I don’t know how long; I am, unashamedly, one of the biggest dinosaur nerds in the world. Thank you to all the people who supported me on the journey of bringing <span class="t9">Jurassic Heart</span> to life—Tush, MJ, and Aleks, and the girls who read the beginning and helped make it shine; to Michael Crichton and Steven Spielberg for igniting a little girl’s passion in long-since extinct animals; Carrie-Anne, who came with me to the Natural History Museum on a dinosaur-seeking mission. And Emily, for the Triceratops named Horny who inspired a tradition.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?0d2eadb6